import { ArrowLeft } from 'lucide-react'
import { Link } from 'react-router-dom'
import Header from '../components/site/Header'
import Footer from '../components/site/Footer'
import { useLanguage } from '@/i18n/LanguageContext'
import useSEO from '../hooks/useSEO'
import usePrerenderReady from '../hooks/usePrerenderReady'

export default function PrivacyPage() {
  const { t } = useLanguage()
  const copy = t.privacy

  useSEO({ title: copy.seoTitle })
  usePrerenderReady()

  return (
    <>
      <Header />
      <main className="bg-cream">
      <div className="mx-auto max-w-3xl px-6 pt-36 pb-16 md:pt-44 md:pb-24">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-ink/60 transition-colors hover:text-terracotta"
        >
          <ArrowLeft className="h-4 w-4" strokeWidth={1.8} />
          {copy.backLink}
        </Link>

        <h1 className="mt-8 font-heading text-2xl leading-tight text-ink md:text-3xl">
          {copy.title}
        </h1>

        <p className="mt-6 text-base leading-relaxed text-ink/80">{copy.intro}</p>

        <div className="mt-10 space-y-10 text-base leading-relaxed text-ink/80">
          {copy.sections.map((section) => (
            <section key={section.heading}>
              <h2 className="font-heading text-xl text-ink">{section.heading}</h2>
              {section.paragraphs.map((paragraph) => (
                <p key={paragraph} className="mt-3">
                  {paragraph}
                </p>
              ))}
              {section.bullets.length > 0 ? (
                <ul className="mt-3 list-disc space-y-2 pl-5">
                  {section.bullets.map((bullet) => (
                    <li key={bullet}>{bullet}</li>
                  ))}
                </ul>
              ) : null}
              {section.outro ? <p className="mt-3">{section.outro}</p> : null}
            </section>
          ))}
        </div>
      </div>
      </main>
      <Footer />
    </>
  )
}
